import React, { useState, useEffect } from 'react';
import { Sparkles, BookOpen, Wand2, FileText, Check } from 'lucide-react';

const GeneratingAnimation = ({ progress }) => {
  const [currentPhase, setCurrentPhase] = useState(0);
  
  const phases = [
    { icon: BookOpen, text: 'Reading your memories...', color: 'text-pink-500' },
    { icon: Wand2, text: 'Weaving your story...', color: 'text-purple-500' },
    { icon: FileText, text: 'Crafting chapters...', color: 'text-blue-500' },
    { icon: Sparkles, text: 'Adding final touches...', color: 'text-yellow-500' }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentPhase((prev) => (prev + 1) % phases.length);
    }, 3000);
    
    return () => clearInterval(interval);
  }, []);

  const Phase = phases[currentPhase];

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-pink-100 to-purple-100 px-4">
      <div className="max-w-md w-full">
        {/* Animated Icon */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-24 h-24 bg-white rounded-full shadow-lg mb-6 float-animation">
            <Phase.icon className={`w-12 h-12 ${Phase.color}`} />
          </div>
          
          <h2 className="text-3xl font-bold text-gray-800 mb-3">
            Creating Your Autobiography
          </h2>
          
          <p className={`text-xl ${Phase.color} font-medium mb-8 fade-in`}>
            {Phase.text}
          </p>
        </div>

        {/* Progress Bar */}
        <div className="bg-white rounded-full p-2 shadow-inner mb-4">
          <div 
            className="h-3 rounded-full bg-gradient-to-r from-pink-400 via-purple-400 to-blue-400 transition-all duration-1000 ease-out"
            style={{ width: `${progress}%` }}
          />
        </div>
        
        <p className="text-center text-gray-600 text-sm">
          {progress}% complete
        </p>

        {/* Fun Facts */}
        <div className="mt-12 glass-effect rounded-2xl p-6">
          <p className="text-sm text-gray-700 leading-relaxed italic text-center">
            "Every life is a unique story worth telling. Your memories are being transformed into a beautiful narrative that will inspire generations to come."
          </p>
        </div>

        {/* Animated Dots */}
        <div className="flex justify-center gap-2 mt-8">
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              className="w-3 h-3 rounded-full bg-purple-400"
              style={{
                animation: `pulse 1.5s ease-in-out ${i * 0.2}s infinite`
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default GeneratingAnimation;
